<template>
  <v-dialog
    :model-value="required"
    persistent
    no-click-animation
    scroll-strategy="none"
    max-width="420"
  >
    <v-card class="force-update-card">
      <v-card-title class="force-update-title">
        {{ t("$vuetify.layout.forceUpdate.title") }}
      </v-card-title>
      <v-card-text class="force-update-body">
        {{ message }}
      </v-card-text>
      <v-card-actions class="force-update-actions">
        <v-btn v-if="!hard" variant="text" color="grey-darken-1" @click="dismiss">
          {{ t("$vuetify.layout.forceUpdate.later") }}
        </v-btn>
        <v-btn block :class="hard ? 'red-lg-bg' : 'primary-lg-bg'" height="40" @click="update">
          {{ t("$vuetify.layout.forceUpdate.updateNow") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from "vue";
import { useLocale } from "vuetify";
import { storeToRefs } from "pinia";
import { useForceUpdateStore } from "@/stores/forceUpdate.store";
import { useForceUpdate } from "@/composables/useForceUpdate.composable";

const { t } = useLocale();
const store = useForceUpdateStore();
const { required, hard, minVersion } = storeToRefs(store);
const { openStore } = useForceUpdate();

const message = computed(() => {
  const base = t("$vuetify.layout.forceUpdate.message");
  return minVersion.value ? `${base} (v${minVersion.value})` : base;
});

const update = () => {
  openStore();
};

const dismiss = () => {
  store.dismiss();
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/variables" as *;

.force-update-card {
  border-radius: 8px;
  padding: 8px;
}

.force-update-title {
  color: $primary;
  font-size: 18px;
  font-weight: 600;
  padding: 16px 16px 4px;
}

.force-update-body {
  color: #333;
  font-size: 15px;
  line-height: 1.5;
  padding: 8px 16px 16px;
}

.force-update-actions {
  padding: 0 12px 12px;
  display: flex;
  gap: 8px;
}
</style>
